'use client';

import React from 'react';

import he from 'he';
import parse from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';

import { allowedTags } from './constants';
// import Lightbox from './Lightbox';
import { options } from './replace';
import EditInAdminButton from '../EditInAdminButton';

import 'react-18-image-lightbox/style.css';
import 'video-react/dist/video-react.css';

const Wrapper = styled.div`
  position: relative;
  max-width: 100%;
  width: 100% !important;

  img,
  iframe {
    max-width: 100%;
  }

  iframe {
    border: 0;
  }
`;

interface ParsedContentProps {
  article?: ArticleData;
  content?: string;
}

export default function ParsedContent({
  article = null,
  content = '',
}: ParsedContentProps) {
  // const [lightboxOpen, setLightboxOpen] = useState(false);
  // const [lightboxIndex, setLightboxIndex] = useState(0);
  const [isHovered, setIsHovered] = React.useState(false);

  // Decode HTML entities first
  let decodedContent = '';
  if (content) {
    decodedContent = content ? he.decode(content) : '';
  }
  if (article) {
    decodedContent = article.content ? he.decode(article.content) : '';
  }

  const sanitizedContent = sanitizeHtml(decodedContent, {
    allowedTags,
    allowedAttributes: false,
    allowedStyles: false,
    allowVulnerableTags: false,
  });

  // const { images, captions } = { images: [], captions: [] };

  const imageCallback = () => {
    // setLightboxOpen(true);
    // setLightboxIndex(images.findIndex(i => i === src));
  };

  // const parsedContent = addIdToHeadings(sanitizedContent, imageCallback);
  const parsedContent = parse(sanitizedContent, options({ imageCallback }));

  return (
    <Wrapper
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <EditInAdminButton item={article} visible={isHovered} />
      {parsedContent}
      {/* {typeof window !== 'undefined' && (
        <Lightbox
          images={images}
          captions={captions}
          lightboxOpen={lightboxOpen}
          lightboxIndex={lightboxIndex}
          setLightboxOpen={setLightboxOpen}
          setLightboxIndex={setLightboxIndex}
        />
      )} */}
    </Wrapper>
  );
}
